<template>
    <div class="main">
        <div class="mainContent">
            <h2 class="card-title">Germline Architecture Screen</h2>
            <p>
                In the Green (2011) screen, germline architecture was monitored by 3D fluorescence confocal microscopy after knock-down of each of the 554 genes required for embryo production. At least three germlines from a strain expressing mCherry-Histone and a GFP-tagged plasma membrane probe were imaged for each knockdown condition. The presence or absence of 94 defects for each condition was manually assessed in a binary fashion; 522 of the knockdowns exhibited a phenotype.  Genes whose knockdown gave similar defect patterns were manually grouped into 29 broad phenotype categories and were further partitioned into 102 phenotypic classes.
                <br/><br/>
                Using this manual classification as a benchmark, we developed a robust computational approach for constructing a gene network. Phenotypic profiles were compared using a similarity measure called the Connection Specificity Index (CSI), a network context-based measure that ranks the significance of functional links between genes (Green et al., 2011). For the germline architecture data, PhenoBank displays the top phenotypic matches for a query gene based on this metric.
                <br/><br/>
                The Sönnichsen (2005) and Green (2011) datasets were integrated into an in silico network that can be viewed at different levels of functional resolution. Functional modularity can be explored at different levels of resolution in the network by dialing up or down the CSI threshold used to display functional connections between genes. The dynamic graphical interface used to visualize the network is N-Browse, an interactive Java-based tool (Kao and Gunsalus, 2008). In N-Browse, the user can display the functional connections identified by the Sönnichsen et al. (2005) and Green et al. (2011) high-content screens using different CSI thresholds and can also display connections based on prior expression correlation and protein-protein interaction data sets.
            </p>

            <h4 class="round">Reference and Link to paper</h4>

            • PMID: <a href="https://pubmed.ncbi.nlm.nih.gov/21529718/" target="_blank">21529718</a>, PMCID: <a href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3086541/" target="_blank">PMC3086541</a>, DOI: <a href="https://doi.org/10.1016/j.cell.2011.03.037" target="_blank">10.1016/j.cell.2011.03.037</a>

          <h4 class="round">Movie</h4>
          <div class="row">
            <div class="col-sm-12">
              <video controls loop autoplay height="200" src="/mov/Control_germline.mp4">
                Sorry, your browser doesn't support embedded videos.
              </video>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: "ProjectDescription.vue",
    metaInfo: {
      title: 'Germline Architecture Screen',
      // override the parent template and just use the above title only
      // titleTemplate: null,
      meta: [
        { vmid: 'description', name: 'description', content: 'In the Green (2011) screen, germline architecture was monitored by 3D fluorescence confocal microscopy after knock-down of each of the 554 genes required for embryo production. At least three germlines from a strain expressing mCherry-Histone and a GFP-tagged plasma membrane probe were imaged for each knockdown condition. The presence or absence of 94 defects for each condition was manually assessed in a binary fashion; 522 of the knockdowns exhibited a phenotype.  Genes whose knockdown gave similar defect patterns were manually grouped into 29 broad phenotype categories and were further partitioned into 102 phenotypic classes.' },
      ]
    },
  }
</script>

<style scoped>
    @import url('~@/assets/bootstrap.css');
    @import url('~@/assets/datatable.css');
    @import url('~@/assets/tooltip.css');

    .main {
        margin: 1.5rem;
    }

    h3 {
      margin: 40px 0 0;
    }
    .round {
      font-family: Calibri, Candara, Segoe, Segoe UI, Optima, Arial;
      border-radius: 7px;
      border: 1px solid #d9d9d9;
      background: #dae3f3;
      padding: 3px 7px 3px 7px;
      font-style: oblique;
      color: #203864;
      font-weight: bold;
    }

    p.strong {
      text-decoration: underline;
      font-style: oblique;
    }

    h2.card-title {
      margin-top: 0;
      color: #2f5597;
      font-style: oblique;
    }

    h5.card-title {
      color: #2f5597;
      font-style: oblique;
      font-weight: bold;
    }

    .mainContent {
      border-radius: 25px;
      border: 2px solid #dae3f3;
      padding: 20px;
    }

    a {
      color: #0066ff;
    }

    p.summary {
      color: #114188;
      line-height: 1.2;
      font-weight: normal;
      font-style: oblique;
      font-size: 15px;
    }

    .modal-title {
      color: #114188;
      font-weight: bold;
      font-size: 18px;
    }

    .modal-mask {
      position: fixed;
      z-index: 9998;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, .5);
      display: table;
      transition: opacity .3s ease;
    }

    .modal-wrapper {
      display: table-cell;
      vertical-align: middle;
    }

    .modal-viewer {
      width: 830px;
    }
</style>
